import { css } from '@emotion/css';

import { colors } from '@ajaibid/components';

export const styMenuListContainer = css`
  padding: 8px;
  align-content: center;
`;

export const styMenuListItem = css`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 12px 8px;
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background-color: ${colors.SLATE_GRAY_1} !important;
  }

  &:active {
    background-color: ${colors.AJAIB_BLUE_1} !important;
  }

  > div:first-child {
    // Force height for icon at 24px
    height: 24px;
  }
`;

export const styTextMenuItem = css`
  display: flex;
  height: 24px;
  justify-content: center;
  padding-top: 2px;
`;

export const styMenuWebVersion = css`
  color: ${colors.SLATE_GRAY_5};
`;

export const styLabelNewMenu = css`
  background-color: ${colors.RED_5};
  color: ${colors.NEUTRAL_0};
  border-radius: 4px;
  margin-left: 8px;
  padding: 0px 4px;
`;
